import { Box } from "@chakra-ui/react";
import React from "react";
import Header from "../../../../components/header";
import Banner from "./components/banner";
import DownloadGuide from "./components/downloadGuide";
import Footer from "../../../../components/footer";
const DownloadPageAonfi = () => {
  return (
    <Box>
      <Header />
      <Banner />
      <DownloadGuide />
      <Footer />
    </Box>
  );
};

export default DownloadPageAonfi;
